import { MapPin, Phone, ArrowUpRight, Instagram, Facebook } from 'lucide-react';
import { RESTAURANT } from '../constants/restaurant';

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-coffee text-brand-cream/90 px-6 md:px-12 lg:px-16 pt-20 md:pt-24 pb-32 md:pb-16 border-t border-brand-cream/10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-12 md:gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <span className="w-16 h-16 rounded-2xl bg-white flex items-center justify-center p-2 shadow-lg shrink-0">
                <img
                  src={RESTAURANT.logoUrl}
                  alt="Sankalp - The Taste of India"
                  className="w-full h-full object-contain"
                />
              </span>
              <div>
                <p className="font-serif text-2xl">Sankalp Restaurant</p>
                <p className="text-[11px] uppercase tracking-[0.25em] text-brand-cream/55 font-semibold">
                  Sunshine Coast · Maroochydore
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-brand-cream/70 leading-relaxed">
              Authentic Indian cuisine, slow-simmered curries, live tandoor and warm
              hospitality on Kingsford Smith Parade.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="#"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-brand-cream/10 hover:bg-brand-gold hover:text-brand-coffee border border-brand-cream/15 flex items-center justify-center transition"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full bg-brand-cream/10 hover:bg-brand-gold hover:text-brand-coffee border border-brand-cream/15 flex items-center justify-center transition"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.28em] text-brand-gold font-bold mb-5">
              Contact
            </p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-brand-gold shrink-0" />
                <span className="text-brand-cream/85">{RESTAURANT.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-brand-gold shrink-0" />
                <a
                  href={`tel:${RESTAURANT.phoneRaw}`}
                  data-testid="footer-phone"
                  className="text-brand-cream/85 hover:text-brand-gold transition"
                >
                  {RESTAURANT.phone}
                </a>
              </li>
            </ul>
          </div>

          {/* CTAs */}
          <div className="md:col-span-3 flex flex-col gap-3">
            <p className="text-[11px] uppercase tracking-[0.28em] text-brand-gold font-bold mb-2">
              Quick Actions
            </p>
            <a
              href={RESTAURANT.orderUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-order-btn"
              className="group inline-flex items-center justify-between gap-2 px-5 py-3.5 rounded-full bg-brand-burgundy text-brand-cream text-xs font-semibold uppercase tracking-[0.22em] hover:bg-brand-gold hover:text-brand-coffee transition-all duration-500"
            >
              Order Online
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
            </a>
            <a
              href={RESTAURANT.bookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-btn"
              className="group inline-flex items-center justify-between gap-2 px-5 py-3.5 rounded-full bg-brand-cream/10 text-brand-cream text-xs font-semibold uppercase tracking-[0.22em] border border-brand-cream/20 hover:bg-brand-cream hover:text-brand-coffee transition-all duration-500"
            >
              Book a Table
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-cream/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-brand-cream/55">
          <p>© {new Date().getFullYear()} Sankalp Restaurant Sunshine Coast. All rights reserved.</p>
          <p>Crafted with warmth in Maroochydore, QLD.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
